import { render, staticRenderFns } from "./CompetitorSelector.vue?vue&type=template&id=17b97a25&scoped=true"
import script from "./CompetitorSelector.vue?vue&type=script&lang=js"
export * from "./CompetitorSelector.vue?vue&type=script&lang=js"
import style0 from "./CompetitorSelector.vue?vue&type=style&index=0&id=17b97a25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b97a25",
  null
  
)

export default component.exports